
import { httpVeryfied, API_URL } from '../config'
import {Http, http} from "../http";

export const getTrannsferByIban = async (ibankref: string):Promise<any> => {
  // return new Promise((resolve, reject) => {
  //   httpVeryfied().get(`${API_URL}transaction/getransactionbyibankref/${ibankref}`)
  //     .then(response => {
  //       if (response) {
  //         resolve(response)
  //       } else {
  //         reject(response)
  //       }
  //     })
  //     .catch(error => {
  //       reject(error)
  //     })
  // })

    const { data } = await http.get(`${API_URL}transaction/getransactionbyibankref/${ibankref}`)
    return data;

}

export const deleteTrannsferByRefNo = (data: any):Promise<any> => {
    return new Promise((resolve, reject) => {
        httpVeryfied().post(`${API_URL}transaction/delete`, data)
            .then(response => {
                if (response) {
                    resolve(response)
                } else {
                    reject(response)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const getInfoByAlias = async (formdata:any,lang:any):Promise<any> => {
    const httpNew = new Http(lang)
    const { data } = await httpNew.post(`${API_URL}ips/info/by-alias`,formdata)
    return data;
}

export const checkLimit = async (formData:any,lang:any):Promise<any> =>{
    const httpNew = new Http(lang)
    const { data } = await httpNew.post(`${API_URL}ips/check/limits`,formData)
    return data;
}

export const receiverDetail = async (ibankref:any,lang:any):Promise<any> => {
    const httpNew = new Http(lang)
    const { data } = await httpNew.post(`ips/receiver-details`, { iban: ibankref })
    return data
}

export const cutOffService = async (formData:any,lang:any):Promise<any> =>{
    const httpNew = new Http(lang)
    const { data } = await httpNew.post(`ips/check/cutoff`,formData)
    return data;
}
export const benefBankAccCheck = async (formdata:any,lang:any):Promise<any> =>{
    const httpNew = new Http(lang)
    const { data } = await httpNew.post(`ips/check/benef-acc-bank`,formdata)
    return  data ;
}

export const IpsNewTransfer = async (formData:any, lang:any):Promise<any> =>{
    const httpNew=new Http(lang)
    const {data} = await httpNew.post(`moneytransfer/ips-transaction`,formData)
    return data;
}